module.exports = __webpack_public_path__ + "img/dev_code.png";